module.exports = {
    visibility: false,
    locked: true,
    title: { de: 'Design & Produktion - Freigabe', en: 'Design & Production - Approval' },
    icon: 'teeth',
    iconPrefix: 'fas',
    iconColor: 'white',
    color: '#A0CC63',
    badgeColor: 'white',
    deletable: false,
    requirePayment: false,

    tabs: [{
        id: 'approval',
        title: 'ProjectDetails.approval',
        icon: 'clipboard-check',
        iconPrefix: 'fas',
        type: 'approval',
        classes: ['part', 'attachment', 'image'],
        form: [
            {
                id: 'employee',
                label: 'Mitarbeiter (Kürzel)',
                type: 'select',
                readonly: true,
            }
        ]
    }]
}
  